<div *ngIf="!isReadOnlyAdmin" class="company-list-header-container">
  <div class="notification-btn-container" *ngIf="!isAdmin">
    <button
      class="support-btn"
      ngbTooltip="My Request Tickets"
      placement="top"
      tooltipClass="tooltip-class"
      (click)="navigateToRequests()"
    >
      <mat-icon>support</mat-icon>
    </button>
    <button 
      class="notification-btn" 
      (click)="openNotificationWindow()"
      tooltipClass="tooltip-class"
      ngbTooltip="Next Action Notifications"
      placement="top"
    >
      <mat-icon>notifications</mat-icon>
      <span class="notification-bubble" 
        *ngIf="(notificationCount$ | async) > 0 && !showspingetprfyears">{{notificationCount$ | async }}
      </span>
    </button>
  </div>
  <!-- Create PRF from File Button -->
  <button class="template-btn" (click)="openCreatePrfFromFileModal()" [disabled]="!isLatestYear">
    <mat-icon>note_add</mat-icon>Create PRF from File
  </button>
  
  <app-button size="medium" buttonType="primary" (click)="addNewForm()" (keydown)="addNewForm()">
    <mat-icon class="new-form-icon">add</mat-icon>Add New Form</app-button
  >
</div>
<div class="pagetitle">
  <ng-container *ngIf="isAdmin; else customerTitle">
    Premium Report Administration : {{ currentYear }}
  </ng-container>
  <ng-template #customerTitle>
    <ng-container *ngIf="custid !== '' && custid !== null">
      {{ groupcode }} - {{ groupname }} : PRF List
    </ng-container>
  </ng-template>
</div>
<div class="pagetitlesubtext">
  Select a PRF number from the table to retrieve a premium report.
</div>
